import { snakeKeyToCamelKeyRecursive } from '@js/str-utils'

const getDefaultState = () => {
  return {
    data: {
      experiencePeriodCategories: [],
      languageCodes: [],
      skillStatusTypes: [],
      subscriptions: [],
      surveyDownloadFileModes: [],
      surveyExpirations: [],
      surveyStates: [],
      timezoneCodes: [],
    },
    fetched: false,
  };
};

const globalVariables = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getClone: state => JSON.parse(JSON.stringify(state)),
    getDefaultSurveyExpiration: state => {
      return state.data.surveyExpirations
        .filter(elem => elem.key.toLowerCase() === 'default')[0];
    },
    getSurveyDownloadFileModeByKey: state => key => {
      const index = state.data.surveyDownloadFileModes
        .findIndex(elem => elem.key === key);
      return index >= 0
        ? state.data.surveyDownloadFileModes[index]
        : null;
    },
    getSurveyStateCompleted: state => {
      return state.data.surveyStates
        .filter(elem => elem.name.toLowerCase() === 'completed')[0].value;
    },
    getSurveyExpirationByType: state => type => {
      const index = state.data.surveyExpirations
        .findIndex(elem => elem.type === type);
      return index >= 0 ? state.data.surveyExpirations[index] : null;
    },
    getSurveyStatePending: state => {
      return state.data.surveyStates
        .filter(elem => elem.name.toLowerCase() === 'pending')[0].value;
    },
    getSubscriptionByType: state => type => {
      const index = state.data.subscriptions.findIndex(elem => elem.type === type);
      return index >= 0 ? state.data.subscriptions[index] : null;
    },
    enterpriseSubscriptionType: state => {
      const index = state.data.subscriptions.findIndex(elem => elem.isEnterprise);
      return index >= 0 ? state.data.subscriptions[index].type : null;
    },
  },
  mutations: {
    initialize (state){
      Object.assign(state, getDefaultState());
    },
    set (state, data) {
      state.data.experiencePeriodCategories = data.experiencePeriodCategories
        .map(elem => snakeKeyToCamelKeyRecursive(elem))
        .sort((a, b) => a.displayOrder - b.displayOrder);
      state.data.languageCodes = data.languageCodes
        .map(elem => snakeKeyToCamelKeyRecursive(elem));
      state.data.skillStatusTypes = data.skillStatusTypes
        .map(elem => snakeKeyToCamelKeyRecursive(elem))
        .sort((a, b) => a.displayOrder - b.displayOrder);
      state.data.subscriptions = data.subscriptions
        .map(elem => snakeKeyToCamelKeyRecursive(elem))
        .sort((a, b) => a.displayOrder - b.displayOrder);
      state.data.surveyDownloadFileModes = data.surveyDownloadFileModes
        .map(elem => snakeKeyToCamelKeyRecursive(elem));
      state.data.surveyExpirations = data.surveyExpirations
        .map(elem => snakeKeyToCamelKeyRecursive(elem))
        .sort((a, b) => a.displayOrder - b.displayOrder);
      state.data.surveyStates = data.surveyStates
        .map(elem => snakeKeyToCamelKeyRecursive(elem));
      state.data.timezoneCodes = data.timezoneCodes
        .map(elem => snakeKeyToCamelKeyRecursive(elem));
      state.initialized = true;
    }
  },
};

export default globalVariables;
